import React from "react";

import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import ViewCustomerProfile from "../../../components/SidetabPages/Customers/ViewCustomerProfile";

const CustomerProfile = () => {
  return (
    <>
      <AnnouncementBar />
      <ViewCustomerProfile />
    </>
  );
};
export default CustomerProfile;
